import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const partialApi = createApi({
  reducerPath: 'partialApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/order/',
    prepareHeaders: (headers, { getState }) => {
      let { auth: { auth } } = getState();
      if (typeof auth == "string") {
        auth = JSON.parse(auth);
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["partial"],
  endpoints: (builder) => ({
    getPartial: builder.query({
      query: (typePartial) => {
        return {
          url: `partial`,
          params: {
            typePartial: typePartial
          }
        }
      },
      providesTags: ["partial"],
    }),

    sendPartial: builder.mutation({
      query: (body) => {
        return {
          url: `send-partial`,
          method: 'POST',
          body: body
        }
      },
      invalidatesTags: ["partial"],
    }),
    acceptPartial: builder.mutation({
      query: (body) => {
        return {
          url: `accept-partial`,
          method: 'POST',
          body: body
        }
      },
      invalidatesTags: ["partial"],
    }),
    getPartialByFilter: builder.mutation({
      query: (body) => ({
        url: '/filter-partial',
        method: 'POST',
        body,
      }),
      providesTags: ["partial"],
    }),
    createOrUpdatePartial: builder.mutation({
      query: (formData) => {
        return {
          url: `partial`,
          method: 'post',
          body: formData
        }
      },
      invalidatesTags: ["partial"],
    }),
    setBoxToPartial: builder.mutation({
      query: (body) => {
        return {
          url: "partial-box",
          method: "DELETE",
          body: body
        }
      },
      invalidatesTags: ["partial"],
    }),
    deliveryTonomex: builder.mutation({
      query: (body) => {
        return {
          url: "partial-nomex",
          method: "POST",
          body: body
        }
      },
      invalidatesTags: ["partial"],
    })
  }),
})

export const { useGetPartialQuery,
  useCreateOrUpdatePartialMutation,
  useSetBoxToPartialMutation,
  useGetPartialByFilterMutation,
  useSendPartialMutation,
  useAcceptPartialMutation,
  useDeliveryTonomexMutation } = partialApi